import { LoquixActionCopy } from './loquix-action-copy.js';

if (!customElements.get('loquix-action-copy')) {
  customElements.define('loquix-action-copy', LoquixActionCopy);
}
